import { useEffect, useState } from 'react';
import kittyAngel from '../components/DailyDigest/Badges/kitty_angel.png';
import kittyAstronaut from '../components/DailyDigest/Badges/kitty_astronaut.png';
import kittyCelebrate from '../components/DailyDigest/Badges/kitty_celebrate.png';
import kittyCoffee from '../components/DailyDigest/Badges/kitty_coffee.png';
import kittyConfuse from '../components/DailyDigest/Badges/kitty_confuse.png';
import kittyCool from '../components/DailyDigest/Badges/kitty_cool.png';
import kittyDetective from '../components/DailyDigest/Badges/kitty_detective.png';
import kittyExcite from '../components/DailyDigest/Badges/kitty_excite.png';
import kittyFlower from '../components/DailyDigest/Badges/kitty_flower.png';
import kittyIdea from '../components/DailyDigest/Badges/kitty_idea.png';
import kittyMusic from '../components/DailyDigest/Badges/kitty_music.png';
import kittyPopsicle from '../components/DailyDigest/Badges/kitty_popsicle.png';
import kittyRead from '../components/DailyDigest/Badges/kitty_read.png';
import kittyRobot from '../components/DailyDigest/Badges/kitty_robot.png';
import kittyScientist from '../components/DailyDigest/Badges/kitty_scientist.png';
import kittySleep from '../components/DailyDigest/Badges/kitty_sleep.png';
import kittySweating from '../components/DailyDigest/Badges/kitty_sweating.png';
import kittyWriting from '../components/DailyDigest/Badges/kitty_writing.png';
import kittyZombie from '../components/DailyDigest/Badges/kitty_zombie.png';
import axios from '../utils/axiosConfig';

// Map of image filenames to imported images
const badgeImages = {
  'kitty_angel.png': kittyAngel,
  'kitty_astronaut.png': kittyAstronaut,
  'kitty_celebrate.png': kittyCelebrate,
  'kitty_coffee.png': kittyCoffee,
  'kitty_confuse.png': kittyConfuse,
  'kitty_cool.png': kittyCool,
  'kitty_detective.png': kittyDetective,
  'kitty_excite.png': kittyExcite,
  'kitty_flower.png': kittyFlower,
  'kitty_idea.png': kittyIdea,
  'kitty_music.png': kittyMusic,
  'kitty_popsicle.png': kittyPopsicle,
  'kitty_read.png': kittyRead,
  'kitty_robot.png': kittyRobot,
  'kitty_scientist.png': kittyScientist,
  'kitty_sleep.png': kittySleep,
  'kitty_sweating.png': kittySweating,
  'kitty_writing.png': kittyWriting,
  'kitty_zombie.png': kittyZombie,
};

const useAchievements = (userId) => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  if (!userId) {
    userId = localStorage.getItem('userID');
  }

  const fetchAchievements = async () => {
    if (!userId) {
      userId = localStorage.getItem('userID');
    }
    if (!userId) {
      return;
    }

    try {
      const response = await axios.get(`/api/v1/achievement/user/${userId}`);
      const data = response.data;
      // Transform the data to match the Badge component's expected format
      const transformedAchievements = data.achievements.map((achievement) => ({
        id: achievement.achievement_id,
        imageUrl:
          badgeImages[achievement.achievement.image_url] || badgeImages['kitty_confuse.png'], // fallback to confused kitty if image not found
        alt: achievement.achievement.name,
        description: achievement.achievement.description,
        // An achievement is locked if achieved_at is null
        locked: achievement.achieved_at === null,
      }));

      setAchievements(transformedAchievements);
      setError(null); // Clear any previous errors on success
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      setLoading(false);
    }
  };

  const initializeAchievements = async () => {
    if (!userId) return;

    try {
      setLoading(true);
      setError(null); // Clear any previous errors
      await axios.post(`/api/v1/achievement/user/${userId}/initialize`);

      // After initializing, fetch the achievements again
      await fetchAchievements();
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAchievements();
  }, [userId]);

  return { achievements, loading, error, initializeAchievements, fetchAchievements };
};

export default useAchievements;
